<mat-card class="plano-card">
  <div>
    <mat-card-title class="plano-x">
      {{ plano.valorEntrada | currency:'BRL' }}
    </mat-card-title>

    <mat-card-subtitle class="valor-parcela" *ngIf="plano.tipo === TipoPlanoEnum.PARCELADO">
      + {{plano.parcelas}}x
      {{(plano.valor) | currency:'BRL'}}
    </mat-card-subtitle>

    <mat-card-subtitle class="valor-parcela" *ngIf="plano.tipo === TipoPlanoEnum.QUITACAO">
      À vista
    </mat-card-subtitle>
  </div>

  <button 
    mat-raised-button 
    (click)="selecionarPlano()"
    color="primary">
    Escolher Plano
  </button>
</mat-card>